module.exports = __webpack_public_path__ + "static/media/KW13all.9e2da95f.JPG";